import { BadgeCheck, MapPin, Building2, Landmark } from "lucide-react";
import { BUSINESS, IMAGES } from "./data";
import { scrollToId } from "./hooks";

const TRUST = [
  { icon: BadgeCheck, label: "25+ Years' Industry Experience" },
  { icon: Building2, label: "Commercial & Domestic Specialists" },
  { icon: MapPin, label: "Scotland & North East England" },
  { icon: Landmark, label: "Part of Dodds Bros | British Bath Company" },
];

const MARQUEE = [
  "SEPHORA EDINBURGH",
  "SUEZ FACILITY ASHINGTON",
  "BLANK STREET COFFEE",
  "25+ YEARS INDUSTRY EXPERIENCE",
  "DUAL SECTOR CAPABILITY",
  "DURHAM TO JOHN O' GROATS",
];

export function Hero() {
  return (
    <>
      <section id="hero" className="bg-[#182330] text-[#eef4f8] pt-20 pb-16 md:pt-28 md:pb-24 border-b border-[#213042] overflow-hidden" data-testid="hero-section">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7">
              <div className="font-mono-code text-xs text-[#00c2a8] uppercase tracking-widest mb-6 flex items-center gap-2">
                <span className="w-2 h-2 bg-[#00c2a8] rounded-full" aria-hidden="true"></span>
                <span>Commercial &amp; Domestic Contracting Network</span>
              </div>

              <h1 className="font-mono-code text-[clamp(32px,5.2vw,68px)] font-bold uppercase tracking-tight text-white leading-[1.02] mb-8">
                <span className="ln"><span>Precision Silicone Sealing.</span></span>
                <span className="ln"><span className="text-[#00c2a8]">Professional Mastic Work.</span></span>
              </h1>

              <p className="font-mono-code text-xs uppercase tracking-widest text-white mb-4" data-testid="hero-subheadline">
                Scotland &amp; North East England&apos;s Silicone &amp; Mastic Specialists
              </p>

              <p className="text-sm md:text-base text-[#a2b8cc] max-w-xl mb-10 leading-relaxed">
                From bathrooms and kitchens to major commercial developments and industrial facilities, we provide
                professional silicone sealing and mastic application services across Scotland and North East England.
                With extensive industry experience and a portfolio including major retail, hospitality and industrial
                projects, we deliver clean, precise and durable finishes on projects of every scale.
              </p>

              <div className="flex flex-wrap items-center gap-4">
                <button
                  onClick={() => scrollToId("contact")}
                  className="font-mono-code bg-[#00c2a8] text-[#111923] font-bold text-xs px-8 py-4 rounded uppercase tracking-wider hover:bg-white transition-colors"
                  data-testid="hero-quote-btn"
                >
                  Get A Free Quote
                </button>
                <button
                  onClick={() => scrollToId("projects")}
                  className="font-mono-code border border-[#30455e] text-white text-xs px-8 py-4 rounded uppercase tracking-wider hover:border-[#00c2a8] transition-colors"
                  data-testid="hero-projects-btn"
                >
                  Explore Our Projects
                </button>
                <a
                  href={BUSINESS.phone1Href}
                  className="font-mono-code text-xs text-[#a2b8cc] hover:text-[#00c2a8] transition-colors py-4"
                  data-testid="hero-phone-link"
                >
                  Direct: {BUSINESS.phone1}
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <figure className="d3-band-reveal relative border border-[#213042] rounded overflow-hidden" data-testid="hero-image-wrap">
                <img
                  src={IMAGES.hero.src}
                  alt={IMAGES.hero.alt}
                  className="w-full aspect-[4/5] md:aspect-[4/4.6] object-cover"
                  loading="eager"
                  fetchPriority="high"
                  data-testid="hero-image"
                />
                <figcaption className="absolute bottom-0 inset-x-0 bg-[#111923]/85 backdrop-blur px-4 py-3 font-mono-code text-[10px] uppercase tracking-widest text-[#00c2a8]">
                  On Site &bull; Commercial Sealing Package
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* Trust strip */}
      <div className="bg-[#111923] border-b border-[#213042]" data-testid="trust-strip">
        <div className="max-w-6xl mx-auto px-6 py-6 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {TRUST.map((t) => (
            <div key={t.label} className="flex items-center gap-3">
              <t.icon className="w-5 h-5 text-[#00c2a8] shrink-0" aria-hidden="true" />
              <span className="font-mono-code text-[11px] uppercase tracking-wider text-white leading-snug">{t.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Marquee spine */}
      <div className="bg-[#111923] border-b border-[#213042] py-5 overflow-hidden" aria-hidden="true">
        <div className="d3-mq-track font-mono-code text-xs uppercase tracking-widest text-[#7d96ac]">
          {[0, 1].map((copy) => (
            <div key={copy} className="flex items-center gap-12 pr-12">
              {MARQUEE.map((m, i) => (
                <span key={`${copy}-${i}`} className={i % 2 === 0 ? "text-white font-bold" : ""}>
                  &bull; {m}
                </span>
              ))}
              <span className="text-[#00c2a8] font-bold">&bull; FREE QUOTATIONS</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
